module.exports = __webpack_public_path__ + "img/logo-aliaddo.4f55be42.svg";